import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Comprehensive ResizeObserver error suppression
const suppressResizeObserver = () => {
  const resizeObserverErr = /ResizeObserver loop/;
  
  // Override console.error
  const originalError = console.error;
  console.error = function(...args) {
    const firstArg = args[0];
    if (typeof firstArg === 'string' && resizeObserverErr.test(firstArg)) {
      return;
    }
    if (firstArg && firstArg.message && resizeObserverErr.test(firstArg.message)) {
      return;
    }
    originalError.apply(console, args);
  };

  // Catch window errors
  window.addEventListener('error', function(e) {
    if (e && e.message && resizeObserverErr.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true);
};

suppressResizeObserver();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
